import { Injectable, Injector } from '@angular/core';
import { MarsHttpDataService } from 'app/mars/services/mars-http-data.service';

@Injectable()
export class MarsQuestionsService extends MarsHttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/questions');
  }

  createGroupQuestions(data: any, groupId) {
    return super.postRequest(`${this.baseUrl}/${groupId}`, data, {});
  }

  cancelQuestion(question: any) {
    const url = `${this.baseUrl}/${question.id}`;
    return this.putRequest(url, { ...question, status: 'CANCELLED' }, this.getRequestOptions());
  }

  publishQuestion(question: any) {
    const url = `${this.baseUrl}/${question.id}`;
    return this.putRequest(url, { ...question, status: 'PUBLISHED' }, this.getRequestOptions());
  }

  certifyQuestion(question: any) {
    const url = `${this.baseUrl}/${question.id}`;
    return this.putRequest(url, { ...question, status: 'CERTIFIED' }, this.getRequestOptions());
  }
}
